module.exports = __webpack_public_path__ + "media/images/newbies-rocket-a7636d93c75e6b1158a4bd6c458a78a2.svg";